export const LEAD_TOOLTIP_DESCRIPTION =
  'The team member selected is the individual that is primarily responsible for the client. If the messaging module is enabled, welcome messages are always sent by the lead.';

export const VISIBILITY_TOOLTIP_DESCRIPTION =
  "The team member/s selected can see the client and the client's associated information. Admins are always selected for all clients.";

export const DELETE_CUSTOM_FIELD_CONFIRMATION =
  'When you delete a property, the property and the values that you have saved for all clients will be deleted.';
